import api from './http';

const buildQuery = (params = {}) => {
  const qs = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v === undefined || v === null || v === '') return;
    qs.append(k, String(v));
  });
  const s = qs.toString();
  return s ? `?${s}` : '';
};

export const listEvents = async (filters = {}) => {
  const { data } = await api.get(`/events${buildQuery(filters)}`);
  if (Array.isArray(data)) return data;
  if (data?.rows) return data.rows;
  return [];
};

/** ALWAYS returns { rows, total, limit, offset } */
export const listEventsPaged = async (filters = {}) => {
  const { data } = await api.get(`/events${buildQuery({ ...filters, paged: true })}`);
  if (Array.isArray(data)) {
    const limit  = Number(filters.limit)  || data.length || 10;
    const offset = Number(filters.offset) || 0;
    return { rows: data, total: data.length, limit, offset };
  }
  return {
    rows:   data?.rows   ?? [],
    total:  Number(data?.total ?? (data?.rows?.length ?? 0)),
    limit:  Number(data?.limit ?? filters.limit ?? 10),
    offset: Number(data?.offset ?? filters.offset ?? 0),
  };
};

export const getEvent = async (id) =>
  (await api.get(`/events/${id}`)).data;

/** form-data if files present */
export const createEvent = async (payload) => {
  const isFormData =
    payload instanceof FormData || payload?.logo instanceof File || payload?.image instanceof File;
  const config = isFormData ? { headers: { 'Content-Type': 'multipart/form-data' } } : {};
  return (await api.post('/events', payload, config)).data;
};

export const updateEvent = async (id, payload) => {
  const isFormData =
    payload instanceof FormData || payload?.logo instanceof File || payload?.image instanceof File;
  const config = isFormData ? { headers: { 'Content-Type': 'multipart/form-data' } } : {};
  return (await api.put(`/events/${id}`, payload, config)).data;
};

export const deleteEvent = async (id) =>
  (await api.delete(`/events/${id}`)).data;

/* Meta with backend path fallback */
export const listCategories = async () => {
  try { return (await api.get('/events/@meta/categories')).data; }
  catch (e) {
    if (e?.response?.status === 404) return (await api.get('/events/meta/categories')).data;
    throw e;
  }
};

export const listSubCategories = async (args = {}) => {
  const q = buildQuery(args);
  try { return (await api.get(`/events/@meta/sub-categories${q}`)).data; }
  catch (e) {
    if (e?.response?.status === 404) return (await api.get(`/events/meta/sub-categories${q}`)).data;
    throw e;
  }
};
